/**
 * @purpose: City Code Setting modal controller - CRUD operations for DIST_TbMDKota
 * @called_by: customer.price.ctrl.js via modalFactory.open()
 * @deps: AngularJS app, urlServices, toaster, modalFactory, $uibModalInstance, params
 * @public: modalCitySettingCtrl
 * @side_effects: loads cities, saves/deletes cities, loads host codes, opens host setting modal
 */
app.controller('modalCitySettingCtrl', ['$scope', '$uibModalInstance', 'urlServices', 'toaster', 'modalFactory', 'params',
    function($scope, $uibModalInstance, urlServices, toaster, modalFactory, params) {

    // Data models
    $scope.cities = [];
    $scope.hostCodes = [];
    $scope.selectedCity = null;
    $scope.isEdit = false;
    $scope.isSaving = false;
    $scope.isLoading = false;
    $scope.filterText = '';

    // Form data
    $scope.formData = {
        CityCode: '',
        CityName: '',
        JenisDestination: 'DOMESTIC',
        HostCode: '',
        HostName: '',
        Contact: '',
        Phone: '',
        Address: '',
        Fax: '',
        Email: '',
        Zona: '',
        IsFullBranch: false
    };

    // Destination types
    $scope.destinationTypes = [
        { code: 'DOMESTIC', name: 'DOMESTIC' },
        { code: 'INTERNATIONAL', name: 'INTERNATIONAL' }
    ];

    /**
     * Load all cities from API
     */
    $scope.loadCities = function() {
        $scope.isLoading = true;
        urlServices.ambilData('api/customer-price/cities', {}, function(err, result) {
            $scope.isLoading = false;
            if (err) {
                toaster.pop('error', 'Error', 'Failed to load cities');
                return;
            }
            $scope.cities = (result && result.dt) ? result.dt : [];
        });
    };

    /**
     * Load host codes for dropdown
     */
    $scope.loadHostCodes = function() {
        urlServices.ambilData('api/customer-price/host-codes', {}, function(err, result) {
            if (err) {
                toaster.pop('error', 'Error', 'Failed to load host codes');
                return;
            }
            $scope.hostCodes = (result && result.dt) ? result.dt : [];
        });
    };

    /**
     * Select city from grid for editing
     */
    $scope.selectCity = function(city) {
        $scope.selectedCity = city;
        $scope.isEdit = true;
        $scope.formData = {
            CityCode: city.CityCode || '',
            CityName: city.CityName || '',
            JenisDestination: city.JenisDestination || 'DOMESTIC',
            HostCode: city.HostCode || '',
            HostName: city.HostName || '',
            Contact: city.Contact || '',
            Phone: city.Phone || '',
            Address: city.Address || '',
            Fax: city.Fax || '',
            Email: city.Email || '',
            Zona: city.Zona || '',
            IsFullBranch: city.IsFullBranch === true || city.IsFullBranch === 1
        };
    };

    /**
     * Clear form for new entry
     */
    $scope.clearForm = function() {
        $scope.selectedCity = null;
        $scope.isEdit = false;
        $scope.formData = {
            CityCode: '',
            CityName: '',
            JenisDestination: 'DOMESTIC',
            HostCode: '',
            HostName: '',
            Contact: '',
            Phone: '',
            Address: '',
            Fax: '',
            Email: '',
            Zona: '',
            IsFullBranch: false
        };
    };

    /**
     * Save city (insert or update)
     */
    $scope.saveCity = function() {
        // Validation
        if (!$scope.formData.CityCode) {
            toaster.pop('warning', 'Validation', 'City Code cannot be empty');
            return;
        }
        if (!$scope.formData.CityName) {
            toaster.pop('warning', 'Validation', 'City Name cannot be empty');
            return;
        }
        if (!$scope.formData.JenisDestination) {
            toaster.pop('warning', 'Validation', 'Type cannot be empty');
            return;
        }
        if (!$scope.formData.HostCode) {
            toaster.pop('warning', 'Validation', 'Host Code cannot be empty');
            return;
        }
        if (!$scope.formData.Contact) {
            toaster.pop('warning', 'Validation', 'Contact cannot be empty');
            return;
        }
        if (!$scope.formData.Email) {
            toaster.pop('warning', 'Validation', 'Email cannot be empty');
            return;
        }

        $scope.isSaving = true;
        urlServices.simpanData('api/customer-price/city', $scope.formData, function(err, result) {
            $scope.isSaving = false;
            if (err) {
                toaster.pop('error', 'Error', err.err || 'Failed to save city');
                return;
            }
            toaster.pop('success', 'Success', result.message || 'City saved successfully');
            $scope.clearForm();
            $scope.loadCities();
        });
    };

    /**
     * Delete selected city
     */
    $scope.deleteCity = function() {
        if (!$scope.selectedCity) {
            toaster.pop('warning', 'Warning', 'Please select a city to delete');
            return;
        }

        if (!confirm('Are you sure you want to delete this city code?')) {
            return;
        }

        $scope.isSaving = true;
        urlServices.hapusData('api/customer-price/city', { CityCode: $scope.selectedCity.CityCode }, function(err, result) {
            $scope.isSaving = false;
            if (err) {
                toaster.pop('error', 'Error', err.err || 'Failed to delete city');
                return;
            }
            toaster.pop('success', 'Success', result.message || 'City deleted successfully');
            $scope.clearForm();
            $scope.loadCities();
        });
    };

    /**
     * Handle host code selection
     */
    $scope.onHostCodeChange = function() {
        var selected = $scope.hostCodes.find(function(h) {
            return h.HostCode === $scope.formData.HostCode;
        });
        if (selected) {
            $scope.formData.HostName = selected.HostName || '';
        } else {
            $scope.formData.HostName = '';
        }
    };

    /**
     * Filter cities by search text
     */
    $scope.getFilteredCities = function() {
        if (!$scope.filterText) {
            return $scope.cities;
        }
        var filter = $scope.filterText.toLowerCase();
        return $scope.cities.filter(function(city) {
            return (city.CityCode && city.CityCode.toLowerCase().indexOf(filter) !== -1) ||
                   (city.CityName && city.CityName.toLowerCase().indexOf(filter) !== -1) ||
                   (city.HostCode && city.HostCode.toLowerCase().indexOf(filter) !== -1);
        });
    };

    /**
     * Open Host Code Setting modal
     * After modal closes, refresh the host codes dropdown
     */
    $scope.showHostSetting = function() {
        modalFactory.open('md', 'modal.host.setting.html', 'modalHostSettingCtrl', {}).result.then(function() {
            $scope.loadHostCodes();
        }, function() {
            // dismissed - still refresh in case changes were made
            $scope.loadHostCodes();
        });
    };

    /**
     * Close modal
     */
    $scope.close = function() {
        $uibModalInstance.dismiss('cancel');
    };

    // Initialize
    $scope.loadCities();
    $scope.loadHostCodes();
}]);
